import React from "react"
import Image from "next/image"

interface EmptyStateProps {
  onRetakePhoto: () => void
}

/**
 * 분석 결과가 없을 때의 빈 상태 컴포넌트
 */
const EmptyState = React.memo<EmptyStateProps>(({ onRetakePhoto }) => {
  return (
    <div className="flex h-full flex-col items-center justify-center px-4">
      <div className="relative mb-6 h-24 w-24 flex-shrink-0">
        <Image
          src="/images/illustrations/shoot_book_list_02.webp"
          alt="책장 촬영 일러스트레이션"
          width={96}
          height={96}
          className="object-contain"
        />
      </div>

      <p className="typo-rl-body2 text-rl-gray-font-caption mb-8 w-full max-w-[291px] text-center font-normal sm:max-w-sm">
        촬영한 책장의 도서 정보를 확인할 수 없습니다.
        <br />
        다른 도서를 촬영하여 등록해 주세요.
      </p>

      <button
        onClick={onRetakePhoto}
        className="bg-rl-primary-normal hover:bg-rl-primary-strong flex h-10 w-[142px] flex-col items-center justify-center gap-[10px] rounded-md px-7 py-4 sm:w-40"
      >
        <div className="flex h-[21px] w-[86px] flex-row items-center justify-center sm:w-24">
          <span className="typo-rl-body2 font-medium text-white">
            책장 다시 촬영
          </span>
        </div>
      </button>
    </div>
  )
})

EmptyState.displayName = "EmptyState"

export default EmptyState